module.exports = __webpack_public_path__ + "img/icon-individuals.8133c648.svg";